<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Utilities</div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <h2>Documents</h2>
      </mat-expansion-panel-header>
      <div class="contents">
        <button mat-raised-button color="primary" (click)="deleteOrphans()">Delete Orphans</button>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <h2>Exports</h2>
      </mat-expansion-panel-header>
      <div class="contents">
        <div>
          <button mat-raised-button class="utility-button" color="primary" (click)="exportProspectiveUsersCSV()">
            Prospective Users
          </button>
        </div>
        <div>
          <button mat-raised-button class="utility-button" color="primary" (click)="exportPremiumAcreageUsersCSV()">
            Premium Acreage Users
          </button>
        </div>
        <div>
          <button mat-raised-button class="utility-button" color="primary" (click)="exportIneligibleUsersCSV()">
            Ineligible Users
          </button>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <h2>Site Validation</h2>
      </mat-expansion-panel-header>
      <div class="contents">
        <div>
          <button mat-raised-button color="primary" class="utility-button" (click)="checkOwnership()">
            Check Ownership
          </button>
        </div>
        <div>
          <form class="admin-form" [formGroup]="adminForm" fcFormUnloadWarning>
            <button mat-raised-button color="primary" class="utility-button" (click)="checkChangeDetection()">
              Change Detection
            </button>
            <mat-form-field>
              <mat-label>Threshold</mat-label>
              <input formControlName="threshold" id="threshold" matInput type="number" />
            </mat-form-field>
          </form>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
